import React from 'react';

const ButtonGroup = ({children, className}) => (<div className={`ey-button-group ${className || ''}`}>{children}</div>);

export default ButtonGroup;
